import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import React from 'react'
import { FaCheckDouble } from 'react-icons/fa'
import CustomButton from '../../../shared/CustomButton'
import DropdownField from '../../../shared/DropdownField'
import { useTranslation } from 'react-i18next'
import { fetchData } from '../../../helpers/fetchData'
import toast from 'react-hot-toast'
import CheckPermission from '../../../hooks/CheckPermission'
import { CANCEL_REASONS, OTHER_CANCEL_REASON } from '../../../constants/CancelReasons'
import { useCancelInvoiceMutation } from '../../../redux/api/modules/billingApi'
const CancelInvoice = ({
  setOpenCancelModal,
  refetch,
  setSelectedInvoiceData,
  selectedInvoiceData
}) => {
  const { hasPermission } = CheckPermission()
  const { t } = useTranslation()
  const [cancelInvoiceMutation, { isLoading: cancelLoading }] = useCancelInvoiceMutation()
  const reasonOptions = CANCEL_REASONS.map(reason => ({ label: t(reason), value: reason }))

  const initialValues = {
    reason_type: '',
    other_reason: '',
    invoice_type: 'both'
  }
  const validationSchema = Yup.object().shape({
    reason_type: Yup.string().trim().required('Reason is required'),
    other_reason: Yup.string().trim().when('reason_type', {
      is: OTHER_CANCEL_REASON,
      then: schema => schema.required('Reason is required'),
      otherwise: schema => schema.notRequired()
    }),
    invoice_type: Yup.string().trim().required('Invoice type is required')
  })

  const handleSubmit = async data => {
    if (!selectedInvoiceData || !hasPermission('invoices', 'update')) return
    try {
       const reason =
        data?.reason_type === OTHER_CANCEL_REASON
          ? data?.other_reason?.trim()
          : data?.reason_type
      const res = await cancelInvoiceMutation({
        invoice_number: selectedInvoiceData?.invoice_number,
        cash_invoice_number: selectedInvoiceData?.cash_invoice_number,
        file_no: selectedInvoiceData?.patient?.file_no,
        reason: reason,
        invoice_type: data?.invoice_type,
      }).unwrap()

      if (res?.message) {
        toast.success(res?.message)
      } else {
        toast.success(t('Invoice cancelled successfully') || 'Invoice cancelled successfully')
      }
      setSelectedInvoiceData(null)
      setOpenCancelModal(false)
      if (refetch) refetch()
    } catch (error) {
      toast.error(error?.data?.message || error?.message || 'Failed to cancel invoice')
    }
  }

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          touched,
          handleChange,
          handleBlur,
          values
        }) => (
          <Form>
            <div className={'mb-3'}>
              <DropdownField
                name='reason_type'
                label={t('Reason for request')}
                placeholder={t('Select reason')}
                options={reasonOptions}
              />
            </div>
            {values.reason_type === OTHER_CANCEL_REASON && (
              <div className={`flex flex-col gap-1 w-full mb-3 `}>
                <label className='input-label'>{t('Reason')}</label>
                <textarea
                  placeholder={t('Enter reason')}
                  className='w-full p-2 bg-gray-100 rounded-lg border border-gray-300 hover:border-primary !outline-none !shadow-none text-[14px]'
                  name='other_reason'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  rows={3}
                />
                {errors.other_reason && touched.other_reason && (
                  <span className='text-sm text-red-500'>{errors.other_reason}</span>
                )}
              </div>
            )}
            <div className='flex items-center justify-end'>
              {hasPermission('invoices', 'update') && <CustomButton
                loading={cancelLoading}
                type='submit'
                icon={<FaCheckDouble size={12} className='me-2' />}
                label={t('Cancel Invoice')}
                buttonType='primary'
              />}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default CancelInvoice
